import range from './range.vue'
export default range
